document.querySelectorAll('[data-gallery-src]').forEach(button => {
  button.addEventListener('click', () => {
    const image = document.getElementById('ProductImage');
    if (!image) return;
    image.removeAttribute('srcset');
    image.src = button.dataset.gallerySrc;
    document.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
});
const variantSelect = document.getElementById('ProductVariant');
variantSelect?.addEventListener('change', () => {
  const option = variantSelect.selectedOptions[0];
  document.getElementById('ProductPrice').textContent = option.dataset.price;
  const button = document.getElementById('AddToBag');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
  const image = document.getElementById('ProductImage');
  if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});
